
export default {
  name: 'items',
  data: () => ({
    categories: [],
    page: 1,
    total: 0,
  }),
  methods: {
  },
  mounted(){
  }
}